import { BaseController } from '../../../../../common/base/controller';

export class UploadWarrantController extends BaseController {
  constructor(
    controllerService,
    ticketService,
    transferringService,
    fdFormFieldsService,
    ticketReaderFactory,
    $filter
  ) {
    'ngInject';
    super({
      controllerService,
      ticketService,
      transferringService,
      fdFormFieldsService,
      ticketReaderFactory,
      $filter
    });
  }

  get ticketId() { return this.$stateParams.ticketId || this.ticket.id; }

  $onInit() {
    // Check access for the given user
    if (!this.isStateAccessible()) {
      this.viewStatus = 'pending';
    }

    // Assign
    this.model = {};
    this.uploaded = false;
    this.isFormValid = false;
    this.breadcrumbs = this.transferringService.states;

    // Set default value for the entry date to today
    this.model.entryDate = new Date();
  }

  /**
   * This state is only accessible for users with the following permissions:
   * - Transferring.Create
   * - Transferring.Handle
   */
  isStateAccessible() {
    let { Permissions } = this.userService;
    let { Create, Handle } = Permissions.transferring;
    return this.userService.hasPermission([Create, Handle]);
  }

  /**
   * Upload the file to create a new ticket.
   */
  upload(file) {
    const { entryDate } = this.model;
    return this.ticketService
      .createOutgoingWithSignedWarrant(file, entryDate)
      .then((data) => {
        this.uploaded = true;
        this.isFormValid = true;
        this.ticket = this.ticketReaderFactory.createForDetail(data.aidRequest);
        return this.ticket;
      });
  }

  showFileUploaded() {
    const { ticketId } = this;
    if (ticketId) {
      this.ticketService.redirectSignedWarrantForm(ticketId);
    }
  }

  submit() {
    const { ticketId } = this;
    this.fdFormFieldsService
      .validate(this.uploadWarrantForm)
      .then(() => {
        let stateName = this.transferringService.nextState(this.stateIndex);
        this.go(stateName, { ticketId });
      });
  }

}
